module.exports = __webpack_public_path__ + "s1.no1.5e5798af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s1.no1.jpg
// module id = FyvE
// module chunks = 0